module.exports = __webpack_public_path__ + "img/52114137_L.3b39a511.png";